var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterHeaterOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 46,
    height: 38,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ef4923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#faa819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ef6f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9855",
    "data-name": "Group 9855",
    transform: "translate(-7998 -1198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(7998 1198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M.313,29.962V7.444A7.078,7.078,0,0,1,7.338.313H38.712A7.035,7.035,0,0,1,45.694,7.4V30.239a7.035,7.035,0,0,1-6.982,7.087H7.568A7.311,7.311,0,0,1,.313,29.962",
    transform: "translate(-0.003 0.002)",
    fill: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M.313,29.962V7.444A7.078,7.078,0,0,1,7.338.313H38.712A7.035,7.035,0,0,1,45.694,7.4V30.239a7.035,7.035,0,0,1-6.982,7.087H7.568A7.311,7.311,0,0,1,.313,29.962Z",
    transform: "translate(-0.003 0.002)",
    fill: "none",
    stroke: "#58595b",
    strokeMiterlimit: 10,
    strokeWidth: 0.625
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M10.27,4.8a5.979,5.979,0,0,0-5.928,6.017V27.171a5.979,5.979,0,0,0,5.928,6.017h5.095a1.063,1.063,0,0,1,1.053,1.07v3.388H19.63V34.258a4.3,4.3,0,0,0-4.265-4.33H10.27a2.742,2.742,0,0,1-2.717-2.758V10.816A2.74,2.74,0,0,1,10.27,8.06H37.677a.883.883,0,0,1,0,1.766H13.58a4.143,4.143,0,0,0,0,8.285h24.1a.883.883,0,0,1,0,1.765H13.58a4.145,4.145,0,0,0,0,8.288h24.1a.883.883,0,0,1,0,1.765h-6.46a4.3,4.3,0,0,0-4.266,4.33v3.388h3.212V34.258a1.064,1.064,0,0,1,1.054-1.07h6.46a4.143,4.143,0,0,0,0-8.285H13.58a.884.884,0,0,1,0-1.767h24.1a4.143,4.143,0,0,0,0-8.285H13.58a.883.883,0,0,1,0-1.765h24.1a4.144,4.144,0,0,0,0-8.287Z",
    transform: "translate(7997.96 1198.028)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(7998 1198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M37.674,5.127a3.818,3.818,0,0,1,0,7.634h-24.1a1.209,1.209,0,0,0,0,2.417h24.1a3.818,3.818,0,0,1,0,7.634h-24.1a1.21,1.21,0,0,0,0,2.419h24.1a3.817,3.817,0,0,1,0,7.633H31.213a1.388,1.388,0,0,0-1.374,1.4v3.061h-2.57V34.26a3.978,3.978,0,0,1,3.944-4h6.461a1.209,1.209,0,0,0,0-2.418h-24.1a3.818,3.818,0,0,1,0-7.635h24.1a1.208,1.208,0,0,0,0-2.417h-24.1a3.817,3.817,0,0,1,0-7.633h24.1a1.209,1.209,0,0,0,0-2.418H10.267a3.063,3.063,0,0,0-3.038,3.082V27.173a3.064,3.064,0,0,0,3.038,3.084h5.095a3.978,3.978,0,0,1,3.943,4v3.061H16.736V34.26a1.387,1.387,0,0,0-1.374-1.4H10.267a5.657,5.657,0,0,1-5.608-5.691V10.817a5.656,5.656,0,0,1,5.608-5.69Zm0-.652H10.267a6.3,6.3,0,0,0-6.25,6.342V27.173a6.3,6.3,0,0,0,6.25,6.344h5.095a.739.739,0,0,1,.732.743v3.714h3.854V34.26A4.627,4.627,0,0,0,15.361,29.6H10.267a2.416,2.416,0,0,1-2.4-2.431V10.817a2.416,2.416,0,0,1,2.4-2.43H37.674a.557.557,0,0,1,0,1.113h-24.1a4.469,4.469,0,0,0,0,8.938h24.1a.557.557,0,0,1,0,1.113h-24.1a4.47,4.47,0,0,0,0,8.94h24.1a.556.556,0,0,1,0,1.112H31.213a4.627,4.627,0,0,0-4.586,4.656v3.714h3.854V34.26a.739.739,0,0,1,.732-.743h6.461a4.47,4.47,0,0,0,0-8.939h-24.1a.557.557,0,0,1,0-1.114h24.1a4.469,4.469,0,0,0,0-8.938h-24.1a.557.557,0,0,1,0-1.113h24.1a4.469,4.469,0,0,0,0-8.938",
    transform: "translate(-0.037 0.026)",
    fill: "#58595b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHeaterOn);
export default __webpack_public_path__ + "static/media/water_heater_on.f45b5eb80e711601df0bc22c89b51916.svg";
export { ForwardRef as ReactComponent };